import React from "react";
import { styled } from "@mui/material/styles";
import { AddNewItemButton } from "./AddNewItemButton";
import { Box } from "@mui/material";

const StyledListbox = styled("ul")(({ theme }) => ({
  margin: 0,
  padding: 0,
  listStyle: "none",
  maxHeight: 250,
  overflow: "auto",
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[4],
  position: "relative",
}));

interface ListboxExerciseWithFooterComponentProps
  extends React.HTMLAttributes<HTMLElement> {
  children?: React.ReactNode;
  onCreateNew?: () => void;
  onlySelectAllowed?: boolean;
  disableAddNewExercise?: boolean;
}

const ListboxExerciseWithFooterComponent = React.forwardRef<
  HTMLUListElement,
  ListboxExerciseWithFooterComponentProps
>(function ListboxExerciseFooterComponent(props, ref) {
  const {
    children,
    onCreateNew,
    onlySelectAllowed,
    disableAddNewExercise,
    ...other
  } = props;

  return (
    <Box>
      <StyledListbox {...other}>{children}</StyledListbox>

      {!onlySelectAllowed && (
        <AddNewItemButton
          handleClick={onCreateNew}
          disabled={disableAddNewExercise}
          text="+ Add new exercise"
        />
      )}
    </Box>
  );
});

export default ListboxExerciseWithFooterComponent;
